/**
 * @class
 * Model to store attribute data for attribute profile items.
 * Specifically used to store attribute's id and associated value.
 * https://kb.netx.net/display/DEV/Attribute+Profiles+for+Folders
 */

import Base from '../models/attribute';

export default class AttributeProfileAttribute extends Base {
	/**
	 * @type {Netx.Rpc}
	 * @private
	 */
	get rpc() {
		return true;
	}

	/**
	 * @type {string}
	 * @private
	 */
	get idAttribute() {
		return 'attributeid';
	}

	/**
	 * @type {object}
	 * @private
	 */
	get defaults() {
		return {
			...super.defaults,
			append: false,
			attributeid: null,
			cleared: false,
			// Our base sets this to 0 be default
			// we will set this as needed when re-ordering
			index: null,
			value: null,
		};
	}

	/** @type {string} */
	static get __name__() {
		return 'AttributeProfileAttribute';
	}
}
